import { debounce } from '../../utils/lodash-replacements';
import ScrollCarousel, { measureSlidesPerView } from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-cms-collection-slider-viewport]',
  track: '[data-cms-collection-slider-track]',
};

// The module element this slider belongs to. Set by `initSlider`.
let container = null;

const sliders = [];

const destroySliders = () => {
  sliders.forEach((slider) => {
    slider.destroy();
  });
  // The array was never emptied before, so each later teardown re-destroyed
  // instances that were already gone.
  sliders.length = 0;
};

const handleSlider = debounce(() => {
  if (sliders.length > 0) {
    destroySliders();
  }

  if (!container) {
    return;
  }

  // Narrow down the search to elements within the container
  const cmsCollectionSliders = container.querySelectorAll('[data-cms-collection-slider]');

  cmsCollectionSliders.forEach((slider) => {
    const tiles = slider.querySelectorAll('[data-product-tile]');
    if (tiles.length === 0) {
      return;
    }
    const tileWidth = tiles[0].offsetWidth;
    const windowWidth = window.innerWidth;
    // Nothing overflows, so there is nothing to slide to.
    if (tiles.length * tileWidth < windowWidth) {
      return;
    }

    const viewport = slider.querySelector(SELECTORS.viewport);
    if (!viewport) {
      return;
    }

    const carousel = new ScrollCarousel(slider, {
      selectors: SELECTORS,
      // Flickity `wrapAround: true`. `contain` is a CSS concern now
      // (scroll-snap-align on the tiles); `arrowShape` is drawn in SCSS.
      loop: true,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      // Several tiles are on screen at once, so the loop must clone a full
      // viewport's worth or the seam shows a gap.
      slidesPerView: measureSlidesPerView(viewport, tiles[0]),
      ariaLabel: 'Collection slider',
    });
    sliders.push(carousel);
  });
}, 250);

const initSlider = (moduleName, i) => {
  // This used to assign the selector *string*, so the `container.querySelectorAll`
  // above threw on every run and this slider never initialized. Resolve the
  // element instead. Ref. WIN-8070.
  container = document.getElementById(`Module-${moduleName}--${i}`);

  window.addEventListener('resize', () => handleSlider());
};

export { destroySliders, initSlider };
